import type { Maybe } from '@vrplatform/utils';
import type { automation as Automation } from '@vrplatform/graphql';

export const getAutomationName = (automation: Maybe<Automation>) => {
  if (!automation) return '';

  return (
    automation.title || automation.ttemplate?.title || 'No automation name'
  );
};
